<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
  ><path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.66618 11.3334C9.66618 11.7016 9.96465 12.0001 10.3328 12.0001H14.9995C15.3677 12.0001 15.6662 11.7016 15.6662 11.3334V6.66673C15.6662 6.29854 15.3677 6.00006 14.9995 6.00006C14.6313 6.00006 14.3328 6.29854 14.3328 6.66673V9.72392L10.2101 5.60119C10.0912 5.4822 9.97531 5.36633 9.86917 5.27622C9.75261 5.17727 9.60468 5.07088 9.41153 5.00813C9.14374 4.92112 8.85528 4.92112 8.58749 5.00813C8.39434 5.07088 8.24642 5.17727 8.12985 5.27622C8.02371 5.36633 7.90785 5.48222 7.78889 5.60121L5.94902 7.44108C5.80924 7.58086 5.73238 7.65698 5.67293 7.70745C5.67057 7.70946 5.66832 7.71135 5.66618 7.71313C5.66404 7.71135 5.66179 7.70946 5.65942 7.70745C5.59997 7.65698 5.52312 7.58086 5.38334 7.44108L2.13758 4.19532C1.87723 3.93497 1.45512 3.93497 1.19477 4.19532C0.934424 4.45567 0.934424 4.87778 1.19477 5.13813L4.44053 8.38389C4.44555 8.38891 4.45056 8.39392 4.45557 8.39893C4.57453 8.51792 4.69038 8.63379 4.79652 8.7239C4.91308 8.82286 5.06101 8.92924 5.25416 8.99199C5.52195 9.079 5.81041 9.079 6.0782 8.99199C6.27134 8.92924 6.41927 8.82286 6.53584 8.7239C6.64198 8.63379 6.75783 8.51792 6.87679 8.39893L8.71667 6.55905C8.85645 6.41926 8.93331 6.34314 8.99276 6.29267C8.99512 6.29066 8.99737 6.28877 8.99951 6.287C9.00165 6.28877 9.0039 6.29066 9.00627 6.29267C9.06571 6.34314 9.14257 6.41926 9.28235 6.55905L13.39 10.6667H10.3328C9.96465 10.6667 9.66618 10.9652 9.66618 11.3334Z"
    fill="currentColor"
  />
</svg>
